// @flow

export const LOGIN = '/login';
export const LOGIN_REMOTE = `${LOGIN}/remote`;
export const LOGIN_VERIFY_USER = `${LOGIN}/verify`;

export const SIGNUP = '/signup';
export const CHECK_PINCODE = `${SIGNUP}/checkpincode`;
export const TERMS_AND_CONDITIONS = '/terms-and-conditions';
export const REGISTER = `${SIGNUP}/register`;

export const HOME = '/';
export const DASHBOARD = '/dashboard';
export const DASHBOARD_OLD = '/dashboard/old';
export const DASHBOARD_COMPANY = `${DASHBOARD}/company`;

export const OUTLETS = '/outlets';
export const OUTLETS_FIND = `${OUTLETS}/find`;
export const OUTLETS_CREATE = `${OUTLETS}/create`;
export const OUTLETS_PROFILE = `${OUTLETS}/profile`;
export const OUTLETS_PROFILE_WITH_OUTLET_ID = `${OUTLETS_PROFILE}/:guid`;

export const MAP = '/map';
export const MAP_OUTLETS_PROFILE = `${MAP}/outlet/profile`;
export const MAP_OUTLETS_PROFILE_WITH_OUTLET_ID = `${MAP_OUTLETS_PROFILE}/:guid`;

export const LOYALTY = '/loyalty';
export const LOYALTY_TRANSACTIONS = `${LOYALTY}/transactions`;

export const ORDERS = '/orders';
export const ORDERS_DETAILS = `${ORDERS}/details`;
export const ORDERS_DETAILS_WITH_ORDER_ID = `${ORDERS_DETAILS}/:orderId`;

export const LEDGERS = '/ledgers';
export const LEDGERS_COMPANY = `${LEDGERS}/company`;
export const LEDGERS_COMPANY_ORDER = `${LEDGERS_COMPANY}/order-details`;
export const LEDGER_COMPANY_WITH_WAREHOUSE_ID = `${LEDGERS_COMPANY}/payments`;
export const LEDGER_COMANY_WITH_OUTLET_COLLECTION_HISTORY_WITH_WAREHOUS_ID = `${LEDGER_COMPANY_WITH_WAREHOUSE_ID}/outlet-collection`;

export const PAYMENTS = '/payments';
export const PAYMENTS_DETAILS = `${PAYMENTS}/details`;
export const PAYMENTS_DETAILS_WITH_WAREHOUSE_ID = `${PAYMENTS_DETAILS}/:warehouseId`;

export const OUTLET_COLLECTION_HISTORY_WITH_WAREHOUS_ID =
  '/outlet-collection/:warehouseId';

export const PAYMENTS_GATEWAY = `${PAYMENTS}/gateway`;
export const PAYMENTS_GATEWAY_NGENIUS = `${PAYMENTS_GATEWAY}/ngenius/:warehouseId`;
export const PAYMENTS_GATEWAY_OPENBANK = `${PAYMENTS_GATEWAY}/openbank/:warehouseId`;

export const FEEDBACK = '/feedback';
export const FEEDBACK_WITH_TYPE = `${FEEDBACK}/:type`;

export const OFFERS = '/offers';
export const PRODUCTS = '/products';
export const NOTIFICATIONS = '/notifications';
export const COLLATERALS = '/collaterals';
export const ACTIVITY = '/activity/:formId';

export const PROFILE = '/profile';
export const PROFILE_EDIT = `${PROFILE}/edit`;

export const CART = '/cart';
export const CART_CHECKOUT = `${CART}/checkout`;

export const SUPPORT = '/support';

export const TREMS_AND_CONDITIONS = '/trems-and-conditions';

export const PRODUCTS_RETURN = '/returns';
export const PRODUCTS_RETURN_NEW = `${PRODUCTS_RETURN}/new`;
export const PRODUCTS_RETURN_NEW_CONFIRM = `${PRODUCTS_RETURN_NEW}/confirm`;
export const PRODUCTS_RETURN_DETAILS_BY_ID = `${PRODUCTS_RETURN}/details/:returnId`;

export const REWARDS = '/rewards';
export const REWARDS_COMPANY = `${REWARDS}/company/:id`;

export const REPORTS = '/reports';
